import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import NProgress from "nprogress";

NProgress.configure({ showSpinner: false, trickleSpeed: 100 });

const ProgressBar = () => {
  const location = useLocation();

  useEffect(() => {
    NProgress.start(); 

    const timeout = setTimeout(() => {
      NProgress.done(); 
    }, 500); 

    return () => {
      clearTimeout(timeout);
      NProgress.done();
    };
  }, [location.pathname]); 

  return null;
};

export default ProgressBar;